import request from "superagent";

import { refreshCredentials } from "../utils/securityUtil";
import { getJwtToken } from "./user";
import env from "../constants/env";

export function sendLearningEvent(userLoginId, userLoginEmail, courseIdentifier, courseName, courseId, courseVersion, courseComments, courseScore, healthStreamContext = {}) {
	const activityInstanceId = `${healthStreamContext.activityInstanceId || ""}`.trim();
	const completionContractVersion = Number(healthStreamContext.completionContractVersion || 0);
	const useVersionedCompletionContract = completionContractVersion >= 2;
	if (useVersionedCompletionContract && !activityInstanceId) {
		return Promise.reject(new Error("An AmbiFi activity instance ID is required to submit versioned HealthStream credit."));
	}

	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			const learningEvent = useVersionedCompletionContract
				? { completionContractVersion: 2 }
				: {};
			Object.assign(learningEvent, {
				"userLoginId": userLoginId,
				"userLoginEmail": userLoginEmail,
				"courseIdentifier": courseIdentifier,
				"courseName": courseName,
				"courseId": courseId,
				"courseVersion": courseVersion,
				"courseComments": courseComments,
				"courseScore": courseScore
			});
			if (useVersionedCompletionContract) {
				Object.assign(learningEvent, {
					sourceType: healthStreamContext.sourceType || "assigned",
					activityInstanceId,
					courseInstanceId: healthStreamContext.courseInstanceId || "",
					containerCourseId: healthStreamContext.containerCourseId || "",
					containerCourseVersion: healthStreamContext.containerCourseVersion || "",
					containerCourseName: healthStreamContext.containerCourseName || ""
				});
			}

			// Ok accept it
			request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.healthStream.learningEvent}`)
				.set("Authorization", getJwtToken())
				.set("Content-Type", "application/json")
				.send(JSON.stringify(learningEvent))
				.then(res => {
					resolve(res.body);
				}).catch(err => {
					reject(err);
				});
		});
	});
}

export async function sendLearningEventForAmbifiActivity(activityId, activityInstanceId, courseComments = "", courseScore) {
	const normalizedActivityId = `${activityId || ""}`.trim();
	const normalizedActivityInstanceId = `${activityInstanceId || ""}`.trim();
	if (!normalizedActivityId) {
		throw new Error("An AmbiFi activity ID is required to submit HealthStream credit.");
	}
	if (!normalizedActivityInstanceId) {
		throw new Error("An AmbiFi activity instance ID is required to submit HealthStream credit.");
	}

	await refreshCredentials();
	const payload = {
		activityId: normalizedActivityId,
		activityInstanceId: normalizedActivityInstanceId,
		courseComments
	};
	if (courseScore !== undefined && courseScore !== null) {
		payload.courseScore = courseScore;
	}

	const response = await request
		.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.healthStream.learningEventForAmbifiActivity}`)
		.set("Authorization", getJwtToken())
		.set("Content-Type", "application/json")
		.send(payload);
	return response.body;
}
